import { useCallback, useEffect, useRef, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Autocomplete, Box, Grid, Paper, TextField, Typography } from "@mui/material";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import { useSelector } from "react-redux";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { PurchaseTableHeader } from "../../../components/datagrid/assetmanagement/purchase/PurchaseTableHeader";
import { useDispatch } from "react-redux";
import {
  getAllCategoryNoLimit,
  getAllSubCatWithNoLimit,
  getAllVendorsWithoutPagination,
  getCategoryTypesNoLimit,
  getPurchasedItems,
} from "../../../redux/features/assetManagementSlice";
import AddOrUpdatePurchase from "./AddOrUpdatePurchase";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import MarkAsDamaged from "./MarkAsDamaged";
import RevertToGoodCondition from "./RevertToGoodCondition";
import { debounce } from "lodash";
import GlobalSelectFieldWithoutFormikNew from "../../../components/mui/GlobalSelectFieldWithoutFormikNew";
import { useLocation } from "react-router-dom";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
const productStatus = [
  { id: -1, name: "All" },
  { id: 1, name: "Damaged" },
  { id: 0, name: "Not Damaged" },
];
const productAvailabiltyStatus = [
  { id: 1, name: "In Stock" },
  { id: 2, name: "In Use" },
];
const PurchaseView = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const damageParamStatus = queryParams.get("productstatus");
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;
  const { loading, purchasedDetails, categoryAllData, categoryTypesNoLimit, allSubCatData, vendorData } = useSelector(
    (store) => store.assetmanagement
  );
  const [typeId, setTypeId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [subCatId, setSubCatId] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [currentRowDetails, setCurrentRowDetails] = useState(null);
  const [poductSts, setProductSts] = useState(damageParamStatus ? productStatus.find((d) => d.name == damageParamStatus) : {});
  const [productAvailablity, setProductAvailability] = useState({});
  const isResettingPage = useRef(false);

  const dispatchParams = {
    paginationData,
    typeId,
    categoryId,
    subCatId,
    vendorId,
    damageStatus: poductSts?.id == undefined ? null : poductSts?.id,
    search,
  };

  //..................IT IS DEPENDECY FOR PAGE RESET TO PAGE NUMBER 1......................///
  useEffect(() => {
    isResettingPage.current = true;
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search, typeId, categoryId, subCatId, vendorId, poductSts]);
  //........................................///

  const debouncedFetchData = useCallback(
    debounce(() => {
      dispatch(getAllCategoryNoLimit());
      dispatch(getCategoryTypesNoLimit());
      dispatch(getAllSubCatWithNoLimit());
      dispatch(getAllVendorsWithoutPagination());
    }, 40),
    []
  );

  useEffect(() => {
    debouncedFetchData();
  }, [debouncedFetchData]);

  useEffect(() => {
    if (pageNum && gridSize) {
      if (isResettingPage.current) {
        if (pageNum == 1) {
          dispatch(getPurchasedItems(dispatchParams));
        }
        isResettingPage.current = false;
        return;
      } else {
        dispatch(getPurchasedItems(dispatchParams));
      }
    }
  }, [gridSize, pageNum, search, typeId, categoryId, subCatId, poductSts?.id, vendorId]);

  const handleChange = (name, id) => {
    if (name == "typeId") {
      setTypeId(id || null);
    } else if (name == "categoryId") {
      setCategoryId(id || null);
    } else if (name == "subCategoryId") {
      setSubCatId(id || null);
    } else if (name == "vendorId") {
      setVendorId(id || null);
    }
  };
  return (
    <GlobalWrapper title={"Purchase"}>
      <Box mb={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={typeId}
                fullWidth
                options={categoryTypesNoLimit}
                getOptionLabel={(option) => option.category_type_name || ""}
                value={categoryTypesNoLimit.find((d) => d.category_type_id == typeId) || null}
                onChange={(e, option) => handleChange("typeId", option?.category_type_id)}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Type Filter" />}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={"categoryId"}
                fullWidth
                options={categoryAllData?.data || []}
                getOptionLabel={(option) => option.category_name || ""}
                value={categoryAllData?.data?.find((d) => d.category_id == categoryId) || null}
                onChange={(e, option) => handleChange("categoryId", option?.category_id)}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Category Filter" />}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={"subCategoryId"}
                fullWidth
                options={allSubCatData}
                getOptionLabel={(option) => option.sub_category_name || ""}
                value={allSubCatData?.find((d) => d.sub_category_id == subCatId) || null}
                onChange={(e, option) => handleChange("subCategoryId", option?.sub_category_id)}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Sub Category Filter" />}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <Autocomplete
                name={"vendorId"}
                fullWidth
                options={vendorData?.data || []}
                getOptionLabel={(option) => option.name || ""}
                value={vendorData?.data?.find((d) => d.vendorID == vendorId) || null}
                onChange={(e, option) => handleChange("vendorId", option?.vendorID)}
                renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Vendor Filter" />}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: "id", itemValue: "name" }}
                data={productStatus}
                label={"Product Status"}
                fullWidth={true}
                selectedDetails={poductSts}
                setChange={setProductSts}
              />
            </Box>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Box>
              <GlobalSelectFieldWithoutFormikNew
                keys={{ itemId: "id", itemValue: "name" }}
                data={productAvailabiltyStatus}
                label={"Product Availability"}
                fullWidth={true}
                selectedDetails={productAvailablity}
                setChange={setProductAvailability}
              />
            </Box>
          </Grid> */}
        </Grid>
      </Box>
      <Box>
        <Paper>
          {currentRowDetails?.productName && (
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
              Product : <strong>{`${currentRowDetails?.productName} ${currentRowDetails.productSerialCode? "- "+ currentRowDetails.productSerialCode :''} `}</strong>
            </Typography>
          )}
          <GlobalDatagrid
            tableHead={PurchaseTableHeader}
            rows={purchasedDetails?.data}
            meta={purchasedDetails?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            setCurrentRowDetails={setCurrentRowDetails}
            actionComponent={
              <>
                <ActionDetails val={rowData?.productName} />
                <GlobalAnchorList component={<AddOrUpdatePurchase row={rowData} dispatchParams={dispatchParams} />} />
                <GlobalAnchorList
                  // label={"Action"}
                  component={<MarkAsDamaged row={rowData} dispatchParams={dispatchParams} />}
                />
                {rowData?.isDamaged != 0 && (
                  <GlobalAnchorList label={"Action"} component={<RevertToGoodCondition row={rowData} dispatchParams={dispatchParams} />} />
                )}
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default PurchaseView;
